import useStockReservationState from 'state/useStockReservationState';
import { IStockOrderDetail } from '../../../../../types/stockOrders';
import StockOrderListOfProducts from './components/StockOrderListOfProducts/StockOrderListOfProducts';
import BordFloatIsland from 'components/BordFloatIsland/BordFloatIsland';
import BordDownloadQrModal from 'components/BordDownloadQrModal/BordDownloadQrModal';
import { IQrCard } from 'components/BordDownloadQrModal/Components/QRcard/QRcard';

interface Tab2ProductsProps {
  stockOrderData: IStockOrderDetail;
  updateWithoutLoaders: () => Promise<void>;
}

const Tab2Products = ({ stockOrderData, updateWithoutLoaders }: Tab2ProductsProps) => {
  const { listOfProducts } = stockOrderData;

  const { stockProductsSelected, setStockProductsSelected, openDownloadModal, setOpenDownloadModal } =
    useStockReservationState();

  const qrList: IQrCard[] = stockProductsSelected?.items?.map(item => ({
    qrData: {
      serial: item.serial,
      productId: item.productId.toString(),
      orgName: 'Stock Propio'
    }
  })) || [];

  const handleOpenCallback = () => setOpenDownloadModal(true);

  const handleCloseCallback = () => {
    setOpenDownloadModal(false);
    setStockProductsSelected(null);
  };

  const qrModal = (
    <BordDownloadQrModal
      downloadPercent={0}
      buttonProps={{
        isButtonDisabled: false,
        handleClick: handleCloseCallback
      }}
      closeModalCallback={handleCloseCallback}
      qrDataProps={qrList}
    />
  );

  return (
    <div className="tab2Products">
      {!!qrList?.length && (
        <BordFloatIsland
          leftContentCount={qrList?.length}
          onClose={handleCloseCallback}
          onButtonClick={handleOpenCallback}
          modal={qrModal}
          isModalOpen={openDownloadModal}
        />
      )}
      <StockOrderListOfProducts listOfProducts={listOfProducts} updateWithoutLoaders={updateWithoutLoaders} />
    </div>
  );
};

export default Tab2Products;
